import {gql} from '@apollo/client';

export const SEND_PHONE_VERIFICATION_CODE_MUTATION = gql`
  mutation sendPhoneVerificationCode($phoneNumber: String!) {
    sendPhoneVerificationCode(phoneNumber: $phoneNumber) {
      sent
      errors
    }
  }
`;
